/* global reelPlaylist */
/* global clipDetails */

import videojs from 'video.js';
import 'videojs-playlist';
import 'videojs-playlist-ui';

const clipEl = document.getElementById('video');
const frameGrab = document.getElementById('wp-admin-bar-grab-frame');
const frameGrabAlert = document.querySelector('.js-frame-notification');
const container = document.querySelector('.c-post__reel');
const xhr = new XMLHttpRequest();
let player = '';

if (clipEl) {
  player = videojs('video');
}

if (typeof reelPlaylist !== 'undefined') {
  player.playlist(reelPlaylist);
  player.playlist.autoadvance(1);
  player.playlistUi({
    playOnSelect: true,
  });

  player.on('playlistitem', () => {
    // Check and remove any current meta
    const currMeta = document.querySelector('.c-post__reel-appendix');
    if (currMeta) {
      currMeta.remove();
    }

    // Add meta into the DOM
    container.insertAdjacentHTML(
      'beforeend',
      reelPlaylist[player.playlist.currentIndex()].clip_meta,
    );
  });
}

function runAwsPost(data) {
  // Begin request
  xhr.open(
    'POST',
    'https://gbyv2cw5e6.execute-api.eu-west-2.amazonaws.com/default/ReplaceAssetPoster-TriggerTranscode-Staging',
  );

  // Configure the request
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('x-api-key', 'TTbOE33Xmf98h2TJ5iyLr23JVNjvdLYu9s4RvgYT');
  xhr.setRequestHeader('Access-Control-Allow-Origin', '*');

  // Request finished callback
  xhr.onreadystatechange = e => {
    if (
      e.target.readyState === XMLHttpRequest.DONE &&
      e.target.status === 200
    ) {
      frameGrabAlert.classList.toggle('c-post__alert--active');
      setTimeout(() => {
        frameGrabAlert.classList.toggle('c-post__alert--active');
      }, 3000);
    }
  };

  // Send Request
  xhr.send(data);
}

if (typeof clipDetails !== 'undefined' && frameGrab && player !== '') {
  frameGrab.addEventListener('click', event => {
    event.preventDefault();
    clipDetails.posterTime = player.currentTime();
    runAwsPost(JSON.stringify(clipDetails));
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/videoplayer.js